import { SystemStore, SystemReducerActions } from './systemTypes'
import { ServerActionTypes, ClientMessageType, EntityTypeEnum } from 'api'
import { getEnumValues } from 'model'

export const initialState: SystemStore = {
  actionLog: [],
  initialSnapshotsLoaded: false,
  entitySnapshotsLoaded: getEnumValues(EntityTypeEnum).reduce((result, entityType) => {
    result[entityType] = false
    return result
  }, {} as Record<EntityTypeEnum, boolean>)
}

const ACTIONS_TO_STORE = 10

export function systemReducer(state: SystemStore = initialState, action: SystemReducerActions): SystemStore {
  const actionLog = state.actionLog.concat(action).slice(-ACTIONS_TO_STORE)

  switch (action.type) {
    case ClientMessageType.LOG_MESSAGE:
      return state

    case ServerActionTypes.ENTITY_STREAM_SNAPSHOTS_END:
      return {
        ...state,
        actionLog,
        initialSnapshotsLoaded: true
      }

    case ServerActionTypes.ENTITY_STREAM_SNAPSHOTS_BEGIN:
      return {
        ...state,
        actionLog
      }

    case ServerActionTypes.ENTITY_SNAPSHOT_BEGIN:
      return {
        ...state,
        actionLog,
        entitySnapshotsLoaded: {
          ...state.entitySnapshotsLoaded,
          [action.payload.entityType]: false
        }
      }

    case ServerActionTypes.ENTITY_SNAPSHOT_END:
      return {
        ...state,
        actionLog,
        entitySnapshotsLoaded: {
          ...state.entitySnapshotsLoaded,
          [action.payload.entityType]: true
        }
      }

    default:
      return {
        ...state,
        actionLog
      }
  }
}
